import React, { useState, useMemo } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import MajorViewSlider from '../../view/slider';
import { useEffect } from 'react';
import moment from 'moment';

/**
 * @description Map() 데이터를 순회하면서 toggles를 만들어줌
 * @param {*} view
 */
function initToggles(view, selectedTab) {
  let result = {};

  if (selectedTab !== 'FINAL') {
    for (let [key] of view.entries()) {
      result[key] = true;
    }
  }

  return result;
}

const MajorDefaultWrapper = ({
  sportsView,
  majorSelected,
  selectedDate,
  setSelectedGame,
  selectedTab,
  toggleEffect
}) => {
  const [toggles, setToggles] = useState(initToggles(sportsView, selectedTab));

  useEffect(() => {
    setToggles(initToggles(sportsView, selectedTab));
    toggleEffect();
  }, [sportsView, selectedTab]);

  const onClickToggle = (type) => {
    setToggles({
      ...toggles,
      [type]: !toggles[type]
    });
    toggleEffect();
  };

  const generateScoreBox = useMemo(() => {
    let todayMatch = [];
    let tomorrowMatch = [];
    let tomorrowDate = '';
    const todayDate = moment(selectedDate).format('YYYY.MM.DD');

    for (let [key, value] of sportsView.entries()) {
      const matchDateTime = moment(value.list[0].startDatetime).format(
        'YYYY.MM.DD'
      );
      if (todayDate !== matchDateTime) {
        tomorrowDate = matchDateTime;
        tomorrowMatch.push(
          <React.Fragment key={key}>
            {selectedTab !== 'FINAL' && (
              <div
                className={clsx(
                  style.game_type,
                  style[value.sportsType.toLowerCase()]
                )}
              >
                <h3 className={style.tit}>{value.league.shortName}</h3>
                <button
                  className={clsx(style.btn_view, !toggles[key] && style.close)}
                  onClick={() => onClickToggle(key)}
                >
                  닫기
                </button>
              </div>
            )}
            {selectedTab === 'FINAL' ? (
              <MajorViewSlider
                list={value.list}
                majorSelected={majorSelected}
                setSelectedGame={setSelectedGame}
                viewType={'DEFAULT_VIEW'}
              />
            ) : (
              toggles[key] && (
                <MajorViewSlider
                  list={value.list}
                  majorSelected={majorSelected}
                  setSelectedGame={setSelectedGame}
                  viewType={'DEFAULT_VIEW'}
                />
              )
            )}
          </React.Fragment>
        );
      } else {
        todayMatch.push(
          <React.Fragment key={key}>
            {selectedTab !== 'FINAL' && (
              <div
                className={clsx(
                  style.game_type,
                  style[value.sportsType.toLowerCase()]
                )}
              >
                <h3 className={style.tit}>{value.league.shortName}</h3>
                <button
                  className={clsx(style.btn_view, !toggles[key] && style.close)}
                  onClick={() => onClickToggle(key)}
                >
                  닫기
                </button>
              </div>
            )}
            {selectedTab === 'FINAL' ? (
              <MajorViewSlider
                list={value.list}
                majorSelected={majorSelected}
                setSelectedGame={setSelectedGame}
                viewType={'DEFAULT_VIEW'}
              />
            ) : (
              toggles[key] && (
                <MajorViewSlider
                  list={value.list}
                  majorSelected={majorSelected}
                  setSelectedGame={setSelectedGame}
                  viewType={'DEFAULT_VIEW'}
                />
              )
            )}
          </React.Fragment>
        );
      }
    }

    return { todayMatch, tomorrowMatch, tomorrowDate };
  }, [sportsView, majorSelected, toggles]);

  return [
    <div
      className={clsx(
        style.sportTypeWrapper,
        selectedTab === 'FINAL' && style.final
      )}
    >
      {generateScoreBox.todayMatch}
    </div>,
    <div
      className={clsx(
        style.sportTypeWrapper,
        selectedTab === 'FINAL' && style.final
      )}
    >
      <h2 className={style.tomorrow}>{generateScoreBox.tomorrowDate}</h2>
      {generateScoreBox.tomorrowMatch}
    </div>
  ];
};

export default MajorDefaultWrapper;
